import { cloneElement, createContext, useContext, useState, useEffect } from 'react';

const TabsContext = createContext();

function TabGroup({ defaultIndex, tabKey, className, children }) {
    // const [activeIndex, setActiveIndex] = useState(parseInt(localStorage.getItem(tabKey) || defaultIndex || 0));
    const [activeIndex, setActiveIndex] = useState(parseInt(defaultIndex || 0));

    return (
        <TabsContext.Provider
            value={{
                activeIndex,
                setActiveIndex: (newIndex) => {
                    setActiveIndex(newIndex);
                    // tabKey && localStorage.setItem(tabKey, newIndex);
                },
            }}
        >
            <input type="hidden" name="tab" value={activeIndex} />
            <div className={`${className || ''}`}>{children}</div>
        </TabsContext.Provider>
    );
}

function TabList({ className, children }) {
    if (!Array.isArray(children)) {
        children = [children];
    }
    return <div className={`${className || ''} border-b`}>{children.map((child, index) => cloneElement(child, { key: index, index: index }))}</div>;
}

function Tab({ index, children }) {
    const { activeIndex, setActiveIndex } = useContext(TabsContext);
    const selected = index === activeIndex;

    return (
        <button
            type="button"
            className={`${selected ? 'border-primary' : 'border-transparent text-gray-500 hover:text-gray-700'} border-b-2 px-4 py-2 transition-colors`}
            onClick={() => {
                setActiveIndex(index);
            }}
        >
            {children}
        </button>
    );
}

function TabPanels({ className, children }) {
    if (!Array.isArray(children)) {
        children = [children];
    }
    return <div className={`${className || ''}`}>{children.map((child, index) => cloneElement(child, { key: index, index: index }))}</div>;
}

function TabPanel({ index, children }) {
    const { activeIndex } = useContext(TabsContext);
    const selected = index === activeIndex;
    return <div className={`${selected ? '' : 'hidden'}`}>{children}</div>;
}

export { TabGroup, TabList, TabPanels, TabPanel, Tab, TabsContext };
